import { Box, Container, Typography } from '@mui/material'
import React, { FunctionComponent, SetStateAction, useContext } from 'react'
import { IReportAction } from '../../../../../shared/services/report-action/report-action.model'
import { ReportPeriodContext } from '../../../../../context/report-periods/report-periods'
import { FloorAreaEstimator } from '../floor-area-estimator'

// Thin wrapper around the shared FloorAreaEstimator for the report-action "utilities" card.
// Passing reportActionId lets the backend mark the action complete on success.
export const EmissionsActionInputUtilities: FunctionComponent<{
  reportAction: IReportAction
  groupId: string,
  setViewActions: React.Dispatch<SetStateAction<any>>,
  getGroup: () => void,
}> = ({
  reportAction,
  groupId,
  setViewActions,
  getGroup,
}) => {
    const reportPeriodContext = useContext(ReportPeriodContext)

    return (
      <Container maxWidth='md' sx={{ pt: 2, pb: 4 }}>
        <Box sx={{ mt: 4 }}>
          {reportAction.location ? (
            <FloorAreaEstimator
              location={reportAction.location}
              reportPeriodId={reportPeriodContext.lastSelectedReportId ?? ''}
              startDate={reportAction.startDate}
              endDate={reportAction.endDate}
              groupId={groupId}
              reportActionId={reportAction.id}
              onSuccess={() => {
                setViewActions('actions')
                getGroup()
              }}
            />
          ) : (
            <Typography variant='body1' sx={{ color: 'text.secondary' }}>
              This action is missing a location.
            </Typography>
          )}
        </Box>
      </Container>
    )
  }
